
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * MarginRateCalculationType enum
 */
class MarginRateCalculationType {
  /**
   * Initialize enum with a given value
   * @param {MarginRateCalculationType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof MarginRateCalculationType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!MarginRateCalculationType}
   * @param {!MarginRateCalculationType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof MarginRateCalculationType)) {
      throw new TypeError('Instance of MarginRateCalculationType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!MarginRateCalculationType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!MarginRateCalculationType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === MarginRateCalculationType.STATIC.value) {
      return 'STATIC'
    }
    if (this.value === MarginRateCalculationType.DYNAMIC.value) {
      return 'DYNAMIC'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!MarginRateCalculationType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!MarginRateCalculationType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!MarginRateCalculationType} Created enum
   */
  static fromObject (other) {
    return new MarginRateCalculationType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
MarginRateCalculationType.STATIC = new MarginRateCalculationType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
MarginRateCalculationType.DYNAMIC = new MarginRateCalculationType(0 + 1)

export { MarginRateCalculationType };

/**
 * Fast Binary Encoding MarginRateCalculationType field model
 */
class FieldModelMarginRateCalculationType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelMarginRateCalculationType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelMarginRateCalculationType}
   * @param {MarginRateCalculationType=} defaults Default value, defaults is new MarginRateCalculationType()
   * @returns {!MarginRateCalculationType} Result value
   */
  get (defaults = new MarginRateCalculationType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new MarginRateCalculationType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelMarginRateCalculationType}
   * @param {!MarginRateCalculationType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelMarginRateCalculationType };
